import projection from '../generated/pwd501f1.json';
import { AcceptanceManifest } from '../types';

export const pwd501f1AcceptanceManifest = projection as AcceptanceManifest;
